import React, { Component } from 'react';
import { Row, Input, Button, DatePicker, message } from "antd";
import moment from 'moment';
import imgSave from "../../saveImg";
import Auth from "../../Auth";

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            note: { note: "" },
            loadingSave: false,
            print: false
        }
    }

    componentDidMount() {
        this.getData(this.state.date)
    }

    getData = (date) => {
        fetch(`/_3_3_3_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({
                note: { ...x.data[0] }
            });
        }).catch(err => {
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = [{
            ...this.state.note,
            year,
            month,
        }];
        if (!data[0].note) {
            message.error('备注不能为空！');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_3_3_3  ', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table3_3_3', 1.5, '6.23', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        return (
            <div className="table7_1_1" style={{ margin: 24 }}>
                <Row id="table3_3_3" style={{ padding: this.state.print ? 20 : 0 }}>
                    <Row style={{ fontSize: 20, color: "#333" }}>
                        6.2.3 Remarks 备注:
                    </Row>
                    <Row className="table-month">
                        <MonthPicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            defaultValue={moment(this.state.date, 'YYYY-MM')}
                            format="YYYY-MM"
                            onChange={(date, str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                    loading: true,
                                    note: { note: "" }
                                });
                                this.getData(str)
                            }}
                        />
                    </Row>
                    <Row style={{ marginTop: 20 }}>
                        <TextArea
                            autosize={{ minRows: 4 }}
                            value={this.state.note.note}
                            placeholder="请输入备注！"
                            onChange={(e) => {
                                this.setState({ note: { ...this.state.note, note: e.target.value } });
                            }}

                        />
                    </Row>
                </Row>
                <Auth loading={this.state.loading} auth="edit_3_3">
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={this.downloadSG}
                            loading={this.state.print}
                        >加入pdf</Button>
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Row>
                </Auth>

            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/table/3.0/3-3/3-3-3.js